import Vue from "vue";
import { getItem } from "./reactive-cache";
import {
  appendItems,
  clearParents,
  insertItems,
  insertItemsBefore,
} from "./relations-adapter";
import { Item } from "./item";
import settings from "./synced-settings";

const selection = new Vue({
  data: {
    idsList: [], // store in a list to keep order
    idsMap: {}, // performance optimization
    insertMode: false,
  },
  computed: {
    length() {
      return Object.values(this.idsMap).length;
    },
    items() {
      if (!this.length) return [];
      return Object.keys(this.idsMap).map((id) => getItem(id));
    },
  },
  methods: {
    has(item) {
      return this.idsMap[item._id];
    },
    add(item) {
      if (!this.idsMap[item._id]) {
        this.idsList.push(item._id);
      }
      Vue.set(this.idsMap, item._id, true);
      if (settings.implicitInsert) {
        this.insertMode = true;
      }
    },
    remove(item) {
      if (this.idsMap[item._id]) {
        const idx = this.idsList.indexOf(item._id);
        this.idsList.splice(idx, 1);
      }
      Vue.delete(this.idsMap, item._id);
      if (this.idsList.length === 0) {
        this.insertMode = false;
      }
    },
    toggle(item) {
      if (this.has(item)) {
        this.remove(item);
      } else {
        this.add(item);
      }
    },
    clear() {
      this.idsMap = {};
      this.idsList = [];
      this.insertMode = false;
    },
    clearParents(relation) {
      const updated = clearParents(this.items, relation);
      Item.saveAll(updated);
      this.clear();
    },
    appendTo(parent) {
      const updated = appendItems(parent, this.items);
      Item.saveAll(updated);
      this.clear();
    },
    insertAt(parent, position) {
      const updated = insertItems(parent, this.items, position);
      Item.saveAll(updated);
      this.clear();
    },
    insertBefore(sibling, parent) {
      const updated = insertItemsBefore(sibling, parent, this.items);
      Item.saveAll(updated);
      this.clear();
    },
    archiveAll() {
      this.items.map((item) => item.archive());
      this.clear();
    },
    deleteAll() {
      this.items.map((item) => item.trash());
      this.clear();
    },
    colorAll(color) {
      this.items.map((item) => item.clone({ color }).save());
      this.clear();
    },
  },
});

export default selection;
